/* eslint-disable valid-jsdoc */
import merge from 'lodash/merge';
/**
 * Use this function to override default `DEFAULT_LAYOUT_THEME`
 */
export function overrideLayoutTheme({ theme, override }) {
    return merge(theme, override);
}
